// オファーフォームの制御
const initOfferForms = () => {
	// すべてのオファーフォームを取得
	const forms = document.querySelectorAll('form[action*="/offers"]')

	forms.forEach((form) => {
		const submitButton = form.querySelector('input[type="submit"]')
		const radioButtons = form.querySelectorAll('input[type="radio"]')

		// 初期状態では登録ボタンを無効化
		if (submitButton) {
			submitButton.disabled = true
			submitButton.classList.add('c-btn--disabled')
		}

		// ラジオボタンの変更イベントを監視
		radioButtons.forEach((radio) => {
			radio.addEventListener('change', () => {
				if (submitButton) {
					// いずれかのラジオボタンが選択されているかチェック
					const isSelected = Array.from(radioButtons).some((r) => r.checked)

					submitButton.disabled = !isSelected
					if (isSelected) {
						submitButton.classList.remove('c-btn--disabled')
					} else {
						submitButton.classList.add('c-btn--disabled')
					}
				}
			})
		})
	})
}

// DOMが読み込まれた後に実行
document.addEventListener('turbolinks:load', initOfferForms)
document.addEventListener('DOMContentLoaded', initOfferForms)
